module.exports = __webpack_public_path__ + "static/img/MAG4.1513864b.jpg";